import { createFileRoute } from '@tanstack/react-router';
import { ResourcesPage } from '@/features/crm/pages/resources-page';

export const Route = createFileRoute('/_app/settings/resources')({ component: ResourcesPage });
